// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Card, Grid } from '../../../lib/base';
import ErrorView from './ErrorView';

const Root = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2),
  },
  margin: 0,
  width: '100%',
}));

const CardContainer = styled(Grid)(() => ({
  maxWidth: 456,
}));

interface Props {
  error?: Error;
  retry?: () => any;
}

function PageError({ error, retry }: Props): React.ReactElement {
  return (
    <Root container justifyContent="center">
      <CardContainer xs={12} sm={8}>
        <Card>
          <ErrorView error={error} retry={retry} />
        </Card>
      </CardContainer>
    </Root>
  );
}

export default PageError;
